/** Registers the MenuBar parser. Its `flat` lives in parser.ts, and its validators in linterParser.ts. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseMenuBar } from './parser';
const menuBarRegistration = {
    typeName: 'MenuBar',
    parser: parseMenuBar,
};
nodeRegistry.register(menuBarRegistration);
//# sourceMappingURL=index.js.map